<form class="list-labour-rates-container">
  <app-labour-rates-filters [filterFormGroup]="filterFormGroup"></app-labour-rates-filters>
  <app-labour-rates-grid [filterFormGroup]="filterFormGroup" class="table-container"></app-labour-rates-grid>
</form>
